import React, { useEffect } from "react";
import { defineMessages } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import { BulkModalContent } from "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import { BulkModalTitle } from "../../../components/modal/BulkModalTitle.js";
import "../../../components/modal/ModalButtons.js";
import { ModalFooter } from "../../../components/modal/ModalFooter.js";
import "@mui/material";
import "../../../components/modal/Modal.style.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import { bulkActionsActions } from "../../bulk-operation/actions.js";
import "../../bulk-operation/components/BulkActionButton.js";
import "../../bulk-operation/epics.js";
import "../../bulk-operation/hooks.js";
import "../../bulk-operation/reducers.js";
import { validationResultsSelector, p2pTransferResultValueSelector } from "../../bulk-operation/selectors.js";
import "rxjs";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../bulk-operation/components/BulkExecutionStepDetailsContent.js";
import "../../bulk-operation/components/BulkExecutionStepModal.js";
import "../../bulk-operation/components/BulkSummaryStepActionItem.js";
import "../../bulk-operation/components/BulkSummaryStepHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../bulk-operation/components/DataGrid.js";
import "../../bulk-operation/components/BulkStepValidationSummary.js";
import "../../../components/progress/CircularProgress.js";
import "../../../components/progress/CircularProgressWithLabel.js";
import "../../bulk-operation/components/BulkSummaryStepActionLabel.js";
import { BulkStepValidationContentFailed, BulkStepValidationContentSuccessful } from "./BulkValidationStepContent.js";
const localized = defineMessages({
  title: {
    id: "BulkStepValidationP2PTransfer_title",
    defaultMessage: "Validation Result"
  },
  cancel: {
    id: "BulkStepValidationP2PTransfer_cancel",
    defaultMessage: "Cancel"
  },
  apply: {
    id: "BulkStepValidationP2PTransfer_apply",
    defaultMessage: "Apply"
  },
  validationFailed: {
    id: "BulkStepValidationP2PTransfer_validationFailed",
    defaultMessage: "Transactions for P2P-transfers are not validated"
  },
  validationSuccess: {
    id: "BulkStepValidationP2PTransfer_validationSuccess",
    defaultMessage: "Transactions for P2P transfer are successfully validated"
  }
});
const BulkTransactionP2PTransferValidationStepModal = ({ onNext, onPrev, agentUid, strategy }) => {
  const dispatch = useDispatch();
  const validationResults = useSelector(
    (state) => validationResultsSelector(state)
  );
  const items = useSelector(p2pTransferResultValueSelector);
  useEffect(() => {
    const request = { transactions: items, agentUid };
    dispatch(bulkActionsActions.validate({ strategy, request }));
    return () => {
      dispatch(bulkActionsActions.setValidationResults(null));
    };
  }, []);
  function handleCancelClick() {
    onPrev();
  }
  function handleNextClick() {
    onNext();
  }
  const invalidTransactions = validationResults?.filter((r) => r.errors?.length > 0);
  const validTransactions = validationResults?.filter((r) => r.errors?.length === 0);
  const isNextDisabled = !validationResults?.length || invalidTransactions?.length > 0;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkModalTitle, { title: localized.title }), /* @__PURE__ */ React.createElement(BulkModalContent, null, validationResults?.length > 0 ? invalidTransactions?.length > 0 ? /* @__PURE__ */ React.createElement(
    BulkStepValidationContentFailed,
    {
      validTransactions,
      invalidTransactions,
      gridColumns: ["uid", "error"],
      alertTitle: localized.validationFailed
    }
  ) : /* @__PURE__ */ React.createElement(
    BulkStepValidationContentSuccessful,
    {
      validTransactions,
      alertTitle: localized.validationSuccess
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null)), /* @__PURE__ */ React.createElement(ModalFooter, null, /* @__PURE__ */ React.createElement(Button, { label: localized.cancel, onClick: handleCancelClick }), /* @__PURE__ */ React.createElement(Button, { color: "primary", label: localized.apply, onClick: handleNextClick, disabled: isNextDisabled })));
};
export {
  BulkTransactionP2PTransferValidationStepModal
};
//# sourceMappingURL=BulkP2PTransferValidationStepModal.js.map
